export default __webpack_public_path__ + "static/media/rabbit35.de775364.gif";